module.exports = __webpack_public_path__ + "img/tsb.aeedd9f0.svg";